import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './category-master.reducer';

export const CategoryMasterDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const categoryMasterEntity = useAppSelector(state => state.categoryMaster.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="categoryMasterDetailsHeading">
          <Translate contentKey="reachamyApp.categoryMaster.detail.title">CategoryMaster</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{categoryMasterEntity.id}</dd>
          <dt>
            <span id="category">
              <Translate contentKey="reachamyApp.categoryMaster.category">Category</Translate>
            </span>
          </dt>
          <dd>{categoryMasterEntity.category}</dd>
        </dl>
        <Button tag={Link} to="/category-master" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/category-master/${categoryMasterEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CategoryMasterDetail;
